'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an inspector Sketch2D control
 *
 * @class
 */

class Sketch2D extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'width': 200,
				'height': 200
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item">
				<div style="width:<%- width %>;height:<%- height %>;" class="editor__inspector__item__sketch2d">
					<canvas width="<%- width %>" height="<%- height %>"></canvas>
					<div class="editor__inspector__item__sketch2d__setting" title="Edit sketch settings">
						<div class="editor__inspector__item__sketch2d__setting__con">
							<input id="sketchCheckbox" class="" type="checkbox" />
							<label class="ui-checkbox-label " for="sketchCheckbox">Snap</label>
						</div>
					</div>
				</div>
			</div>
		`;

		this.SketchTheme = {
			'Tinkercad': {
				background: '#F9F9F9',
				backgroundLine: '#a5ddef',
				pathLine: 'rgba(0,192,255,0.9)',
				controlPoint: 'rgba(0,0,0,0.7)',
				controlPointBG: 'rgba(255,255,255,1.0)',
				controlPointHitBG: 'rgba(255,0,0,1.0)'
			}
		}

		super.render();

	   this._chkSnap = this.$el.find('input');
	   this._canvas = this.$el.find('canvas')[0];
	   this._canvasWidth = $(this._canvas).width() || parseInt($(this._canvas).attr('width'));
		this._canvasHeight = $(this._canvas).height() || parseInt($(this._canvas).attr('height'));
		this._ctx = this._canvas.getContext("2d");
	   this._sketch2D;

	   /**
		* Get/Set an underlying Sketch2D object from which control is drawn.
		*
		* @param {CoreLibrary.Sketch2D} value - the value that you want to get/set
		*/
	   Object.defineProperty(this, 'value', {
	       get : function() {
	       	//TODO: need to return deep copy of an object with prototype inheritance
	       	return this._sketch2D.clone();
	       },
	       set : function (sketch2d) {
	       	// When we undo/redo, we only restore the data directly and it will pass raw data here
	       	// We need convert it to a Sketch2D object
	       	if(!(sketch2d instanceof CoreLibrary.Sketch2D) && sketch2d) {
	       		sketch2d = new CoreLibrary.Sketch2D(sketch2d);
	       	}
				this._sketch2D = sketch2d;
				this._reset();
				this.$el.trigger('Cioui:Inspector:value', this.value);
			},
	       enumerable : true
	   });

	   this._tol = 0.5;
	   this._snapValue;
		this._snapping = false;
		this.refreshTheme();

		/**
		* Enable/Disable snapping
		*
		* @param {boolean} snap
		*/
		Object.defineProperty(this, "snap",{
			get : function () {
				return this._snapping;
			},
			set : function (snap) {
				this._snapping = snap;
				this._chkSnap.checked = snap;
			},
			enumerable : true
		});

	   this._dragging = false;

		//center of user control
		this._cX = this._canvasWidth/2;
		this._cY = this._canvasHeight/2;

		this._initialize();

	}

	_initialize() {
		this._snapping = this._chkSnap.checked;
		this._bindEvents();
	}

	refreshTheme() {
		this._theme = this.SketchTheme.Tinkercad;
		if(this._sketch2D) this._draw();
	};

	resize(size) {
		if(!size) return;

		this._canvasWidth = parseInt(size);
		this._canvasHeight = this._canvasWidth;

		//find new center
		this._cX = this._canvasWidth/2;
		this._cY = this._canvasHeight/2;

		//update size
		$(this._canvas).attr('width', this._canvasWidth);
		$(this._canvas).attr('height', this._canvasHeight);
		$(this.$el).width(this._canvasWidth);
		$(this.$el).height(this._canvasHeight);

		this._reset();
	};

	remove() {
		this.$el.remove();
	};

	_reset() {
		if(this._sketch2D) {
			//center of bounding box
			var bounds = this._sketch2D.bounds();
			if(bounds) {
				var min = bounds.min;
				var max = bounds.max;

			   this._sX = min.x + (max.x - min.x) / 2;	// Example position on Sketch (X)
				this._sY = min.y + (max.y - min.y) / 2;	// Example position on Sketch (Y)

				this._s2cScaleX = (this._canvasWidth / (bounds.length() + 20)); //Define the X scale from Sketch --> User Control + some value
				this._s2cScaleY = (-this._canvasHeight / (bounds.width() + 20)); //Define the Y scale from Sketch --> User Control + some value

				var zero = this._viewToSketch2D(0,0);
				var dragPoint = this._viewToSketch2D(5,5); //Drag handle width-height
				this._tol = zero.distanceTo(dragPoint);

				zero = this._sketch2DToView(0,0);
				var snapPoint = this._sketch2DToView(1,1); //Draw 1mm snap grid
				this._snapValue = zero.distanceTo(snapPoint);
				this._draw();
			}
		}
	};

	_bindEvents() {
		var me = this;
		this._chkSnap.bind('change', function(e) {
			me._snapping = $(e.target).prop("checked");
		});

		var mouseCoords = function(ev) {
			if (ev.pageX || ev.pageY) {
				return {
					x:ev.pageX,
					y:ev.pageY
				};
			}
			return {
				x: ev.clientX + document.body.scrollLeft - document.body.clientLeft,
				y: ev.clientY + document.body.scrollTop  - document.body.clientTop
			};
		};

		var getMouseOffset = function(ev) {
			ev = ev || window.event;
			var targetOrig = getElementOrigin();
			var mousePos  = mouseCoords(ev);
			return {
				x: mousePos.x - targetOrig.x,
				y: mousePos.y - targetOrig.y
			};
		};

		var getElementOrigin = function() {
			var offset = $(me._canvas).offset();
			return {
				x: offset.left,
				y: offset.top
			};
		};

		this._canvas.addEventListener("mousemove", function(ev) {
			if (me._dragging)
				return;

			ev = ev || window.event;

			var mousePos = getMouseOffset(ev);

			me._hit = me._hitTest(mousePos.x, mousePos.y);
			me._draw();

		}, false);

		this._canvas.addEventListener("contextmenu", function(ev) {
			if (ev.preventDefault)
				ev.preventDefault();
		}, false);

		this._canvas.addEventListener("mousedown", function(ev) {
			ev = ev || window.event;
			if (ev.preventDefault)
				ev.preventDefault();

			//focus out other element
			document.activeElement.blur();

			var mousePos = getMouseOffset(ev);

			if (ev.which === 1 && me._hit !== null) {
				me._dragStartX = mousePos.x;
				me._dragStartY = mousePos.y;

				var point = me._sketch2DToView(me._hit.position.x, me._hit.position.y);
				me._dragOrigX = point.x;
				me._dragOrigY = point.y;

				me._dragging = true;
				me.$el.trigger('Cioui:Inspector:beginChange', me.value);
			}

			me._draw();

		}, false);

		this.$el[0].addEventListener("mouseup", function(ev) {
			ev = ev || window.event;
			if (ev.preventDefault)
				ev.preventDefault();

			if(me._dragging)
				me.$el.trigger('Cioui:Inspector:endChange', me.value);

			me._dragging = false;
			me._draw();

		}, false);

		this.$el[0].addEventListener("mousemove", function(ev) {
			// Handle view dragging
			if (!me._dragging)
				return;
			ev = ev || window.event;
			var mousePos = getMouseOffset(ev);

			if (me._hit !== null) {
				var dx = mousePos.x - me._dragStartX;
				var dy = mousePos.y - me._dragStartY;
				var newPoint2D;
				if (me._snapping) {
					newPoint2D = me._viewToSketch2D(Math.round((me._dragOrigX + dx)/me._snapValue)*me._snapValue, Math.round((me._dragOrigY + dy)/me._snapValue)*me._snapValue);
				} else {
					newPoint2D = me._viewToSketch2D(me._dragOrigX + dx, me._dragOrigY + dy);
				}

				var movedToNewPoint = !me._hit.position.equals(newPoint2D);
				if(movedToNewPoint) { //if hit point is moved to new location, calculate (dx,dy) so can move cps by that distance
					var p1 = me._sketch2DToView(me._hit.position.x, me._hit.position.y);
					var p2 = me._sketch2DToView(newPoint2D.x, newPoint2D.y);
					dx = p2.x - p1.x;
					dy = p2.y - p1.y;
				}

				me._hit.position = newPoint2D;
				var pathLength = me._sketch2D.paths.length;
				for (var i = 0; i < pathLength; i++) {
					if(me._sketch2D.paths[i] === me._hit.curve.path) {
						var updateCPoint = function(curveIndex, cPointIndex, point) {
							var cPoints = me._sketch2D.paths[i].curveAt(curveIndex).controlPoints;
							cPoints[cPointIndex] = point;
							me._sketch2D.paths[i].curveAt(curveIndex).controlPoints = cPoints;
						};

						if(me._hit.curveStart || me._hit.curveEnd) { //start or end point hit
							if(me._hit.curveStart) {
								me._sketch2D.paths[i].curveAt(me._hit.curve.index).start = newPoint2D;
							} else {
								me._sketch2D.paths[i].curveAt(me._hit.curve.index).end = newPoint2D;
							}
							if (me._hit.curve instanceof CoreLibrary.Bezier2D && me._hit.controlPoint && movedToNewPoint) { //move control points along with start/end point
								var movePoint = function(point) {
									var v1 = me._sketch2DToView(point.x, point.y).move(dx, dy);
									return me._viewToSketch2D(v1.x, v1.y);
								};
								if(me._hit.controlPoint.length === 2) {
									var cp1 = movePoint(me._hit.controlPoint[0]);
									var cp2 = movePoint(me._hit.controlPoint[1]);
									me._hit.controlPoint[0] = cp1;
									me._hit.controlPoint[1] = cp2;

									if(me._hit.curveStart) {
										updateCPoint(me._hit.curve.index, 0, cp1);
										var prevCurveIndex;
										me._hit.curve.prev() ? prevCurveIndex = me._hit.curve.prev().index : prevCurveIndex = me._sketch2D.paths[i].lastCurve().index;
										updateCPoint(prevCurveIndex, 1, cp2);
									} else {
										updateCPoint(me._hit.curve.index, 1, cp1);
										var nextCurveIndex;
										me._hit.curve.next() ? nextCurveIndex = me._hit.curve.next().index : nextCurveIndex = me._sketch2D.paths[i].firstCurve().index;
										updateCPoint(nextCurveIndex, 0, cp2);
									}
								} else if (me._hit.controlPoint.length === 1) {
									var cp1 = movePoint(me._hit.controlPoint[0]);
									me._hit.controlPoint[0] = cp1;
									updateCPoint(me._hit.curve.index, 0, cp1);
								}
							}
						} else if(me._hit.controlPoint) { //control point hit
							updateCPoint(me._hit.curve.index, me._hit.controlPoint[0], newPoint2D);
							if(!ev.altKey && me._hit.controlPoint.length === 2) {
								var rPoint, curv;
								if(0 === me._hit.controlPoint[0]) { //fist control point hit
									curv = me._hit.curve.prev() ? me._hit.curve.prev() : me._sketch2D.paths[i].lastCurve();
									rPoint = newPoint2D.clone();
									rPoint.rotate(Math.PI, curv.end.x, curv.end.y);
								} else { //last control point
									curv = me._hit.curve.next() ? me._hit.curve.next() : me._sketch2D.paths[i].firstCurve();
									rPoint = newPoint2D.clone();
									rPoint.rotate(Math.PI, curv.start.x, curv.start.y);
								}

								updateCPoint(curv.index, me._hit.controlPoint[1], rPoint);
							}

						} else { //path hit

						}
					}
				}

			}

			me._draw();
			if(me._hit !== null)
				me.$el.trigger('Cioui:Inspector:value', me.value);

		}, false);

	};

	_drawBG() {
		// Clear bg.
		this._ctx.fillStyle = this._theme.background;
		this._ctx.fillRect(0,0,this._canvasWidth,this._canvasHeight);

		this._ctx.beginPath();
		for (var i = 0; i < this._canvasWidth; i += this._snapValue) {
			this._ctx.moveTo(i+0.5,0);
			this._ctx.lineTo(i+0.5,this._canvasHeight);
		}
		for (var i = 0; i < this._canvasHeight; i += this._snapValue) {
			this._ctx.moveTo(0,i+0.5);
			this._ctx.lineTo(this._canvasWidth,i+0.5);
		}
		this._ctx.lineWidth = 0.5;
		this._ctx.strokeStyle = this._theme.backgroundLine;
		this._ctx.closePath();
		this._ctx.stroke();

		this._ctx.beginPath();
		this._ctx.moveTo(0,0);
		this._ctx.lineTo(this._canvasWidth, 0);

		this._ctx.moveTo(this._canvasWidth, 0);
		this._ctx.lineTo(this._canvasWidth,this._canvasHeight);

		this._ctx.moveTo(this._canvasWidth,this._canvasHeight);
		this._ctx.lineTo(0,this._canvasHeight);

		this._ctx.moveTo(0,this._canvasHeight);
		this._ctx.lineTo(0,0);

		this._ctx.lineWidth = 2.0;
		this._ctx.closePath();
		this._ctx.strokeStyle = this._theme.pathLine;
		this._ctx.stroke();
	};

	_draw() {
		//Draw bg
		this._drawBG();

		var pathLength = this._sketch2D.paths.length, me = this;
		var drawDragPoint = function(x, y, hit) {
			me._ctx.fillStyle = me._theme.controlPoint;
			me._ctx.beginPath();
			me._ctx.rect(x-4,y-4,8,8);
	 		me._ctx.closePath();
			me._ctx.fill();

			// centers
			if(hit) {
				me._ctx.fillStyle = me._theme.controlPointHitBG;
			} else {
				me._ctx.fillStyle = me._theme.controlPointBG;
			}
			me._ctx.beginPath();
			me._ctx.rect(x-2,y-2,4,4);
			me._ctx.closePath();
			me._ctx.fill();
		};

		var drawControlPoint = function(x, y, hit) {
			me._ctx.fillStyle = me._theme.controlPoint;
			me._ctx.beginPath();
			me._ctx.arc(x,y,4,0,Math.PI*2,true);
	 		me._ctx.closePath();
			me._ctx.fill();

			// centers
			if(hit) {
				me._ctx.fillStyle = me._theme.controlPointHitBG;
			} else {
				me._ctx.fillStyle = me._theme.controlPointBG;
			}
			me._ctx.beginPath();
			me._ctx.arc(x,y,2,0,Math.PI*2,true);
			me._ctx.closePath();
			me._ctx.fill();
		};

		var drawHitPoint = function() {
			if (me._hit) {
				var point = me._sketch2DToView(me._hit.position.x, me._hit.position.y);
				if(me._hit.curveStart || me._hit.curveEnd) { //End point hit
					drawDragPoint(point.x, point.y, true);
				} else if(undefined !== me._hit.controlPoint) { //control point hit
					drawControlPoint(point.x, point.y, true);
				}
			}
		};

		var setLineDash = function(isSet) {
			var dash = [];
			if(isSet) {
				dash = [3];
			}
			if (!me._ctx.setLineDash) { //Firefox
		   	me._ctx.mozDash = dash;
			} else { //Chrome
				me._ctx.setLineDash(dash);
			}
		};

		//Draw polygons
		for (var i = 0; i < pathLength; i++) {
			var polygons = this._sketch2D.paths[i].toPolygons();
			var polygonLength = polygons.length;

			for (var j = 0; j < polygonLength; j++) {
				var points = polygons[j];
				var npts = points.length/2;

				this._ctx.beginPath();
				for (var k = 0; k < npts; k++) {
					var point = this._sketch2DToView(points[k*2+0], points[k*2+1]);
					if (k === 0) {
						this._ctx.moveTo(point.x, point.y);
					} else {
						this._ctx.lineTo(point.x, point.y);
					}
				}

				this._ctx.closePath();
				this._ctx.lineWidth = 2.0;
				this._ctx.strokeStyle = this._theme.pathLine;
				this._ctx.stroke();

			}

			//Draw drag handles for each curve,
			var curve = this._sketch2D.paths[i].firstCurve();
			while(curve) {
				var startPoint = this._sketch2DToView(curve.start.x, curve.start.y);
				var endPoint = this._sketch2DToView(curve.end.x, curve.end.y);

				if(curve instanceof CoreLibrary.Bezier2D) {
					var controlPoints = curve.controlPoints;
					if(controlPoints.length === 2) { //Cubic Bezier
						var len = controlPoints.length/2;
						for (var c = 0; c < len; c++) {
							var controlPoint1 = this._sketch2DToView(controlPoints[c].x, controlPoints[c].y);
							var controlPoint2 = this._sketch2DToView(controlPoints[c+1].x, controlPoints[c+1].y);

							setLineDash(true);
							this._ctx.beginPath();
							this._ctx.moveTo(controlPoint1.x, controlPoint1.y);
							this._ctx.lineTo(startPoint.x, startPoint.y);

							this._ctx.moveTo(controlPoint2.x, controlPoint2.y);
							this._ctx.lineTo(endPoint.x, endPoint.y);

							this._ctx.lineWidth = 1.0;
							this._ctx.strokeStyle = this._theme.controlPoint;
							this._ctx.closePath();
							this._ctx.stroke();
							setLineDash(false);

							drawControlPoint(controlPoint1.x, controlPoint1.y);
							drawControlPoint(controlPoint2.x, controlPoint2.y);
						}
					} else if (controlPoints.length === 1) { //Quadratic Bezier
						var controlPoint = this._sketch2DToView(controlPoints[0].x, controlPoints[0].y);

						setLineDash(true);
						this._ctx.beginPath();
						this._ctx.moveTo(controlPoint.x, controlPoint.y);
						this._ctx.lineTo(startPoint.x, startPoint.y);

						this._ctx.moveTo(controlPoint.x, controlPoint.y);
						this._ctx.lineTo(endPoint.x, endPoint.y);

						this._ctx.lineWidth = 1.0;
						this._ctx.strokeStyle = this._theme.controlPoint;
						this._ctx.closePath();
						this._ctx.stroke();
						setLineDash(false);

						drawControlPoint(controlPoint.x, controlPoint.y);
					}

				}
				drawDragPoint(startPoint.x, startPoint.y);
				drawDragPoint(endPoint.x, endPoint.y);

				curve = curve.next();
			}

	   }

	   //Draw hit
	   drawHitPoint();

	};

	_sketch2DToView(sketch2DX, sketch2DY) {
		var userControlX = this._cX + ((sketch2DX - this._sX) * this._s2cScaleX);
		var userControlY = this._cY + ((sketch2DY - this._sY) * this._s2cScaleY);
		return new CoreLibrary.Point2D(userControlX, userControlY);
	};

	_viewToSketch2D(canvas2DX, canvas2DY) {
		var sketch2DX = this._sX + ((canvas2DX - this._cX) / this._s2cScaleX);
		var sketch2DY = this._sY + ((canvas2DY - this._cY) / this._s2cScaleY);
		return new CoreLibrary.Point2D(sketch2DX, sketch2DY);
	};


	_hitTest(x, y) {
		var hit = { position: null, curve: null, curveStart: null, curveEnd: null, controlPoint: null };
		var sketchPoint = this._viewToSketch2D(x, y);
		var point = new CoreLibrary.Point2D(sketchPoint.x, sketchPoint.y);
		var pathLength = this._sketch2D.paths.length;
		for (var i = 0; i < pathLength; i++) {
			var curves = this._sketch2D.paths[i].curvesByPoint(point, this._tol); //curves nearby given mouse position
			// Priority 1: Check if the point hit start or end point
			for (var j = curves.length - 1; j > -1; j--) {
				var curve = curves[j];
				if(point.distanceTo(curve.start) < this._tol) {
					hit = {'position': curve.start, 'curve': curve, 'curveStart': true};
					if (curve instanceof CoreLibrary.Bezier2D) { // Only Bezier curves have control points
						if(!hit.controlPoint) hit.controlPoint = [];
						if(curve.controlPoints.length === 2) { //Cubic bezier
							hit.controlPoint.push(curve.controlPoints[0]);
							var prevCurve;
							curve.prev() ? prevCurve = curve.prev() : prevCurve = this._sketch2D.paths[i].lastCurve();
							if(prevCurve instanceof CoreLibrary.Bezier2D && prevCurve.controlPoints && prevCurve.controlPoints.length === 2) {
								hit.controlPoint.push(prevCurve.controlPoints[1]);
							}
						} else if (curve.controlPoints.length === 1) { //quadratic bezier
							hit.controlPoint.push(curve.controlPoints[0]);
						}
					}
					break;
				} else if (point.distanceTo(curve.end) < this._tol) {
					hit = {'position': curve.end, 'curve': curve, 'curveEnd': true};
					if (curve instanceof CoreLibrary.Bezier2D) { // Only Bezier curves have control points
						if(!hit.controlPoint) hit.controlPoint = [];
						if(curve.controlPoints.length === 2) { //Cubic bezier
							hit.controlPoint.push(curve.controlPoints[1]);
							var nextCurve;
							curve.next() ? nextCurve = curve.next() : nextCurve = this._sketch2D.paths[i].firstCurve();
							if(nextCurve instanceof CoreLibrary.Bezier2D && nextCurve.controlPoints && nextCurve.controlPoints.length === 2) {
								hit.controlPoint.push(nextCurve.controlPoints[0]);
							}
						} else if (curve.controlPoints.length === 1) { //qudratic bezier
							hit.controlPoint.push(curve.controlPoints[0]);
						}
					}
					break;
				}
	   	}

			// Priority 2: Check if any control point is hit
			for (var j = curves.length - 1; j > -1; j--) {
				var curve = curves[j];
				if (curve instanceof CoreLibrary.Bezier2D) { // Only Bezier curves have control points
					var controlPoints = curve.controlPoints;
					for (var k = 0; k< controlPoints.length; k++) {
						if(point.distanceTo(controlPoints[k]) < this._tol) {
							hit = {'position': controlPoints[k], 'curve': curve};
							if(!hit.controlPoint) hit.controlPoint = [];
							if(controlPoints.length === 2) { //Cubic bezier
								if(k===0) { //first control point hit
									var prevCurve;
									curve.prev() ? prevCurve = curve.prev() : prevCurve = this._sketch2D.paths[i].lastCurve();
									if(prevCurve instanceof CoreLibrary.Bezier2D && prevCurve.controlPoints && prevCurve.controlPoints.length === 2) {
										hit.controlPoint = [k, k+1];
									} else {
										hit.controlPoint = [k];
									}
								} else { //second control point hit
									var nextCurve;
									curve.next() ? nextCurve = curve.next() : nextCurve = this._sketch2D.paths[i].firstCurve();
									if(nextCurve instanceof CoreLibrary.Bezier2D && nextCurve.controlPoints && nextCurve.controlPoints.length === 2) {
										hit.controlPoint = [k, k-1];
									} else {
										hit.controlPoint = [k];
									}
								}
							} else if (controlPoints.length === 1) { //Quadratic bezier
								hit.controlPoint = [k];
							}
							break;
						}
					}
				}
			}

		}

		if (!hit.position)
			hit = null;

		return hit;

	};

}
module.exports = Sketch2D;

